import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class CustomTransactionLocationError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.kind.validation.custom-transaction-location.is-empty');
    }
}
